import { MessageService } from 'primeng/api';
import { ExtraCurricularActivityRequest, LevelOfAchievement } from './../../models/account/extra-curricular/extraCurricularRequest';
import { CourseWorkRequest } from './../../models/account/coursework/courseworkRequest';
import { SearchInstituteResponse } from './../../models/institute/searchInstituteResponse';
import { CompleteProfileService } from '../../services/account/complete-profile.service';
import { countryResponse } from './../../models/country/countryResponse';
import { UtilityService } from '../../services/utility/utility.service';
import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormsModule, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MultiSelectModule } from 'primeng/multiselect';
import { majorsData } from '../../utility/data/majors-list';
import { DemoGraphyResponse } from '../../models/account/demographyResponse';
import { DemographyRequest } from '../../models/account/demographyRequest';
import { DialogModule } from 'primeng/dialog';
import { InstituteService } from '../../services/institute/institute.service';
import { TestScoreRequest } from '../../models/account/test-score/testScoreRequest';
import { TestScoreResponse } from '../../models/account/test-score/testScoreResponse';
import { classRankLessThanClassSizeValidator, graduateClassRankLessThanClassSizeValidator, undergraduateClassRankLessThanClassSizeValidator } from '../../utility/classRankLessThanClassSizeValidator';
import { atLeastOneCheckedValidator } from '../../utility/atLeastOneCheckedValidator';
import { CustomValidators } from 'ngx-custom-validators';
import { HighSchoolGradesRequest } from '../../models/account/grades/gradesRequest';
import { BoardsResponse } from '../../models/board/boardResponse';
import { CourseWorkResponse } from '../../models/account/coursework/courseWorkResponse';
import { ActivityDetails } from '../../models/account/extra-curricular/extraCurricularRequest';
import { Router } from '@angular/router';
import { ExtraCurrcularActivityComponent } from "./extra-currcular-activity/extra-currcular-activity.component";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PageResponse } from '../../models/institute/randomInstituteResponse';
import { UserSelectors } from '../../states/user/user-selector';
import { Store } from '@ngxs/store';
import { UserStateModel } from '../../states/user/user-state-model';
import { forkJoin, of, switchMap, tap } from 'rxjs';
import { CalendarModule } from 'primeng/calendar';
import { TechnicalSkills, TechnicalSkillsRequest } from '../../models/account/extra-curricular/technicalSkillsRequest';
import { LicenseCertification, LicensesCertificationsRequest } from '../../models/account/extra-curricular/licensesCertificationsRequest';
import { Activity } from '../../models/account/extra-curricular/activity/activityResponse';
import { ValidationError } from 'ngx-awesome-uploader';
import { CourseLevelEnum, CourseLevelEnumDescriptions } from '../../models/enums/courseLevelEnum';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

enum steps {
  demography,
  testscore,
  grades,
  coursework,
  extracurricular
}

interface place {
  name: string
}

@Component({
  selector: 'app-complete-your-profile',
  standalone: true,
  imports: [
    DropdownModule, AutoCompleteModule, RadioButtonModule, InputTextModule, ProgressSpinnerModule,
    MultiSelectModule, DialogModule, ButtonModule, CheckboxModule, FormsModule,
    InputNumberModule, TooltipModule, CommonModule, ReactiveFormsModule,
    ExtraCurrcularActivityComponent, CalendarModule, 
  ],
  templateUrl: './complete-your-profile.component.html',
  styleUrls: ['./complete-your-profile.component.scss']
})
export class CompleteYourProfileComponent implements OnInit , OnChanges{
  formGroup!: FormGroup;
  steps = steps;
  currentStep: steps = steps.demography;
  loading: boolean = false;
  countries: countryResponse[] = [];
  completeProfileForm: FormGroup | any;
  submitted: boolean = false;
  // majors: any = majorsData.groupedMajors;
  majors: string[] = [];
  boards: BoardsResponse[] = [];
  activitiesLoaded: boolean = false;
  technicalSkillsLoaded: boolean = false;
  licenseAndCertificationLoaded: boolean = false;

  destinationCountries = [
    { label: 'India', value: 'IN', icon: '../../../assets/icons/india-flag.svg', id: 'india' },
    { label: 'UK', value: 'GB', icon: '../../../assets/icons/uk.svg', id: 'uk' },
    { label: 'Canada', value: 'CA', icon: '../../../assets/icons/canada.svg', id: 'canada' },
    { label: 'USA', value: 'US', icon: '../../../assets/icons/usa.svg', id: 'usa' },
    { label: 'Other', value: 'Other', icon: '../../../assets/icons/other.png', id: 'other' },
  ];

  // degreePrefs = [
  //   { name: 'Bachelors', key: 'Bachelors' },
  //   { name: 'Masters', key: 'Masters' },
  //   { name: 'Certification Course', key: 'Certification Course' },
  //   { name: 'Phd', key: 'Phd' },
  // ];
  degreePrefs = [
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsDegree], key: CourseLevelEnum.BachelorsDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsAndMastersDegree], key: CourseLevelEnum.BachelorsAndMastersDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Certificate], key: CourseLevelEnum.Certificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Diploma], key: CourseLevelEnum.Diploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.DoctoralDegree], key: CourseLevelEnum.DoctoralDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.DualDegree], key: CourseLevelEnum.DualDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.FoundationDegree], key: CourseLevelEnum.FoundationDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.MastersDegree], key: CourseLevelEnum.MastersDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateCertificate], key: CourseLevelEnum.PostgraduateCertificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateDiploma], key: CourseLevelEnum.PostgraduateDiploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PreSessionalProgram], key: CourseLevelEnum.PreSessionalProgram },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateCertificate], key: CourseLevelEnum.UndergraduateCertificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateDiploma], key: CourseLevelEnum.UndergraduateDiploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Vocational], key: CourseLevelEnum.Vocational }
  ]

  heightestEducationAttained = [
    { name: 'High School', key: 'Grade 12' },
    { name: 'Undergraduate degree', key: 'Undergraduate degree' },
    { name: 'Post Graduate degree', key: 'Post Graduate degree' },
    { name: 'Undergraduate diploma', key: 'Undergraduate diploma' },
    { name: 'Post Graduate diploma', key: 'Post Graduate diploma' },
  ];

  applyingAs = [
    { name: 'I have residence rights in the country I want to apply to', key: 'I have residence rights in the country I want to apply to' },
    { name: 'I plan to apply as international', key: 'I plan to apply as international' }
  ];

  genders = [
    { name: 'Male', value: 1 },
    { name: 'Female', value: 2 },
    { name: 'Other', value: 3 }
  ];

  financialAidPlans = [
    { name: 'I plan to apply for financial aid with my application', key: 'I plan to apply for financial aid with my application' },
    { name: 'I do not plan to apply for financial aid', key: 'I do not plan to apply for financial aid' },
    { name: 'I don’t know yet', key: 'I don’t know yet' },
    { name: 'I plan to apply for private scholarships', key: 'I plan to apply for private scholarships' },
    { name: 'I plan to secure an education loan', key: 'I plan to secure an education loan' },
  ];

  subjects = [
    { key: "Algebra", value: "Algebra" },
    { key: "Geometry", value: "Geometry" },
    { key: "Calculus", value: "Calculus" },
    { key: "Math", value: "Math" },
    { key: "Biology", value: "Biology" },
    { key: "Chemistry", value: "Chemistry" },
    { key: "Physics", value: "Physics" },
    { key: "Environmental Science", value: "Environmental Science" },
    { key: "English", value: "English" },
    { key: "History/Social Science", value: "History/Social Science" },
    { key: "Foreign Language", value: "Foreign Language" },
    { key: "Physical Education", value: "Physical Education" },
    { key: "Art", value: "Art" },
    { key: "Computer Science", value: "Computer Science" },
    { key: "Other", value: "Other" }
  ];

  filteredCities: string[] = [];
  cities: string[] = [];
  institutes: SearchInstituteResponse[] = [];
  demography: DemoGraphyResponse | null | undefined;
  testScore: TestScoreResponse | null | undefined;
  grades: HighSchoolGradesRequest | null | undefined;
  courseWork: CourseWorkResponse | null | undefined;
  extraCurricularActivityResponse: PageResponse<ActivityDetails> | null | undefined;
  technicalSkillsResponse: PageResponse<TechnicalSkills> | null  | undefined;
  licensesCertificationsResponse: PageResponse<LicenseCertification> | null | undefined;
  currentActivityIndex: number = 0;
  activities: Activity[] | null | undefined;

  currentTechnicalSkillIndex: number = 0;
  currentLicenseAndCertificationIndex: number = 0;

  user: UserStateModel | undefined;
  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    private utilityService: UtilityService,
    private completeProfileService: CompleteProfileService,
    private instituteService: InstituteService,
    private messageService: MessageService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.loadCitiesByCountry();
  }

  ngOnInit(): void {
    this.buildForm();
    this.loadBoards();
    this.loadForm();
    this.loadActivities();
  }

  getCourseLevelEnumDescription(courseLevel: CourseLevelEnum){
    return CourseLevelEnumDescriptions[courseLevel];
  }

  filterCities(event: AutoCompleteCompleteEvent){
    const query = event.query?.toLowerCase();
    if(!query || query.length < 3){
      this.filteredCities = [];
      return;
    }
    this.filteredCities = this.cities.filter(city => city.toLowerCase()
    .includes(query))
    .slice(0, 20);
  }

  loadCitiesByCountry() {
    const countryCode = this.completeProfileForm?.value?.demography?.homeCountry;
    if(!countryCode){
      return;
    }
    const selectedCountry = this.countries.find(country => country.countryCode === countryCode);
    const countryName = selectedCountry?.name;
    if (!countryName) {
      return;
    }

    this.utilityService.getCitiesByCountry(countryName).subscribe({
      next: (response) => {
        this.cities = response.data;
      },
      error: (error) => {
        console.warn('Error loading cities:', error);
        this.cities = [];
      }
    });
  }

  loadForm() {
    this.store.select(UserSelectors.getUser).pipe(
      switchMap(user => {
        if (!user || !user.id) {
          return of(null)
        }
        this.user = user;
        return forkJoin({
          countries: this.utilityService.getCountries(),
          demography: this.completeProfileService.getDemography(user.id), // ✅ No empty string
          testScore: this.completeProfileService.getTestScore(user.id),
          grades: this.completeProfileService.getGrades(user.id),
          courseWork: this.completeProfileService.getCourseWork(user.id),
          technicalSkills: this.completeProfileService.getTechnicalSkills(user.id),
          licensesAndCertifications: this.completeProfileService.getLicensesCertifications(user.id),
        });
      }),
      switchMap(response => {
        if(response!=null){
          this.countries = response.countries.result;
          this.demography = response.demography;
          this.testScore = response.testScore;
          this.grades = response.grades;
          this.courseWork = response.courseWork;
          this.technicalSkillsResponse = response.technicalSkills;
          this.licensesCertificationsResponse = response.licensesAndCertifications;
          
          return this.completeProfileService.getExtraCurricular(this.user?.id ?? '');
        }
        return of(null);
      })
    ).subscribe({
      next: (extraCurricular) => {
        if(extraCurricular!=null){
          this.extraCurricularActivityResponse = extraCurricular;
          this.buildForm();
          this.loadCitiesByCountry();
          this.setDatesFromApiResponse(this.completeProfileForm.value.demography);
          //setTimeout is risky as it is just waits and hopes for things to settle 
          //therefore is fragile and unpredictable
          // setTimeout(() => this.setExtraCurricularActvities(), 500);
          Promise.resolve().then(() => {
            this.setExtraCurricularActvities();
            this.cdr.detectChanges();
          });
        }
      },
      error: (error) => console.warn('Error in API calls:', error)
    });
  }

  filterIntendedMajors(event: AutoCompleteCompleteEvent){
    if(event.query.length > 3){
      this.instituteService.listInstituteCourseNames({
        courseLevel: this.completeProfileForm.value.demography.degreePreference,
        courseName: event.query
      }).subscribe({
        next: (response) => {
          this.majors = response.result;
        }
      })
    }else{
      this.majors = [event.query]
    }
  }

  setDatesFromApiResponse(demographyData: any): void {
    const demographyFormGroup = this.completeProfileForm.get('demography') as FormGroup;

    if (demographyData.highSchoolStartDate) {
      const date = this.convertStringToDate(demographyData.highSchoolStartDate);
      if (date) {
        demographyFormGroup.get('highSchoolStartDate')?.setValue(date);
      }
    }
    if (demographyData.highSchoolEndDate) {
      const date = this.convertStringToDate(demographyData.highSchoolEndDate);
      if (date) {
        demographyFormGroup.get('highSchoolEndDate')?.setValue(date);
      }
    }
    if (demographyData.underGraduateStartDate) {
      const date = this.convertStringToDate(demographyData.underGraduateStartDate);
      if (date) {
        demographyFormGroup.get('underGraduateStartDate')?.setValue(date);
      }
    }
    if (demographyData.underGraduateEndDate) {
      const date = this.convertStringToDate(demographyData.underGraduateEndDate);
      if (date) {
        demographyFormGroup.get('underGraduateEndDate')?.setValue(date);
      }
    }
    if (demographyData.graduateStartDate) {
      const date = this.convertStringToDate(demographyData.graduateStartDate);
      if (date) {
        demographyFormGroup.get('graduateStartDate')?.setValue(date);
      }
    }
    if (demographyData.graduateEndDate) {
      const date = this.convertStringToDate(demographyData.graduateEndDate);
      if (date) {
        demographyFormGroup.get('graduateEndDate')?.setValue(date);
      }
    }
    console.log('Form after setting dates:', this.completeProfileForm.value);
  }

  convertStringToDate(dateString: string | null): Date | null {
    if (!dateString) {
      return null;
    }

    const parts = dateString.split('-');
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
      const day = parseInt(parts[2], 10);

      // Create Date object in local time to avoid timezone shifts when displaying in p-calendar
      const localDate = new Date(year, month, day);

      if (isNaN(localDate.getTime())) {
         console.error(`Invalid date string received by convertStringToDate: ${dateString}`);
         return null;
      }
      return localDate;
    } else {
      console.error(`Invalid date string format received by convertStringToDate: ${dateString}`);
      return null;
    }
  }

  loadBoards() {
    this.completeProfileService.getBoards().subscribe({
      next: (response) => {
        this.boards = response.result;
        this.boards = [...this.boards, {
          id: -1,
          name: 'Other'
        }];
      },
      error: (error) => {
        console.warn('Error in loading Boards');
      }
    });
  }

  onBoardSelection($event: DropdownChangeEvent) {
    var control = this.completeProfileForm.get('courseWork.otherBoardName');
    if ($event.value === -1) {
      control?.setValidators([Validators.required]);
    }
    else {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }

  onSubjectCheck($event: CheckboxChangeEvent, subjectName: string): void {

    const otherSubjectControl = this.completeProfileForm.get('courseWork.otherSubjectName');

    if (subjectName === 'Other') {
      if ($event.checked.includes('Other')) {
        otherSubjectControl?.setValidators([Validators.required]);
      } else {
        otherSubjectControl?.clearValidators();
      }

      otherSubjectControl?.updateValueAndValidity();
    }
  }

  // filterPlaces(event: AutoCompleteCompleteEvent) {
  //   if (event.query.length > 3) {
  //     this.utilityService.getOLAPlaces(event.query).subscribe({
  //       next: (response: OlaPlacesResponse) => this.places = response.predictions.map(item => ({ name: item.description })),
  //     });
  //   } else {
  //     this.places = [{ name: event.query }];
  //   }
  // }

  filterInstitutes(event: AutoCompleteCompleteEvent) {
    if (event.query.length > 3) {
      this.instituteService.searchInstitute(event.query).subscribe({
        next: (response: SearchInstituteResponse[]) => this.institutes = response,
      });
    } else {
      this.institutes = [{ name: event.query }];
    }
  }

  test: number = 0;

  private buildForm() {
    this.completeProfileForm = this.formBuilder.group({
      demography: this.formBuilder.group({
        homeCountry: [this.demography?.homeCountry ?? '', Validators.required],
        homeCity: [this.demography?.homeCity ?? '', Validators.required],
        destination: [this.demography?.destination ?? '', Validators.required],
        degreePreference: [this.demography?.degreePreference ?? '', Validators.required],
        highestLevelEducation: [this.demography?.highestLevelEducation ?? '', Validators.required],
        applyingAs: [this.demography?.applyingAs ?? '', Validators.required],
        gender: [this.demography?.gender ?? '', Validators.required],
        financialAid: [this.demography?.financialAid ?? '', Validators.required],
        familySpendingAbility: [this.demography?.familySpendingAbility ?? ''],
        householdIncome: [this.demography?.householdIncome ?? ''],
        highSchoolName: [this.demography?.highSchoolName ?? '', !this.demography?.highSchoolNameisNotListed
          ? [Validators.required]
          : []],
        highSchoolNameisNotListed: [this.demography?.highSchoolNameisNotListed ?? false, this.demography?.highSchoolNameisNotListed ? [Validators.required] : []],
        intendedMajor: [this.demography?.intendedMajor ?? ''],
        isLegacyRelationship: [this.demography?.isLegacyRelationship ?? false],
        parentsGraduationSchool: [this.demography?.parentsGraduationSchool ?? ''],
        highSchoolStream: [this.demography?.highSchoolStream ?? '', Validators.required],
        highSchoolStartDate: [this.demography?.highSchoolStartDate ?? null, Validators.required],
        highSchoolEndDate: [this.demography?.highSchoolEndDate ?? null, Validators.required],
        underGraduateCollageName: [this.demography?.underGraduateCollageName ?? ''],
        underGraduateMajorOrDegree: [this.demography?.underGraduateMajorOrDegree ?? ''],
        underGraduateFieldOfStudy: [this.demography?.underGraduateFieldOfStudy ?? ''],
        underGraduateStartDate: [this.demography?.underGraduateStartDate ?? null],
        underGraduateEndDate: [this.demography?.underGraduateEndDate ?? null],
        graduateCollageName: [this.demography?.graduateCollageName ?? ''],
        graduateMajorOrDegree: [this.demography?.graduateMajorOrDegree ?? ''],
        graduateFieldOfStudy: [this.demography?.graduateFieldOfStudy ?? ''],
        graduateStartDate: [this.demography?.graduateStartDate ?? null],
        graduateEndDate: [this.demography?.graduateEndDate ?? null],
      }),
      testScoreForm: this.formBuilder.group({
        isStanardizedTestNotGiven: [this.testScore?.isStanardizedTestNotGiven ?? false],
        satScoreCheck: [this.testScore?.satScores ? true : false],
        satScores: [this.testScore?.satScores],
        actScoresCheck: [this.testScore?.actScores ? true : false],
        actScores: [this.testScore?.actScores],
        greScoresCheck: [this.testScore?.greScores ? true : false],
        greScores: [this.testScore?.greScores],
        gmatScoresCheck: [this.testScore?.gmatScores ? true : false],
        gmatScores: [this.testScore?.gmatScores],
        apExams: this.formBuilder.array([]),
        isEnglishProficiencyTestNotGiven: [this.testScore?.isEnglishProficiencyTestNotGiven ?? false],
        toeflScoresCheck: [this.testScore?.toeflScores ? true : false],
        toeflScores: [this.testScore?.toeflScores],
        ieltsScoresCheck: [this.testScore?.ieltsScores ? true : false],
        ieltsScores: [this.testScore?.ieltsScores],
        duolingoScoresCheck: [this.testScore?.duolingoScores ? true : false],
        duolingoScores: [this.testScore?.duolingoScores]
      }),
      grades: this.formBuilder.group({
        CGPACheck: [this.grades?.highSchoolGrades?.type === 'CGPA' ? true : false],
        CGPAScore: [this.grades?.highSchoolGrades?.type === 'CGPA' ? this.grades?.highSchoolGrades?.score : ''],
        PercentageCheck: [this.grades?.highSchoolGrades?.type === 'Percentage' ? true : false],
        PercentageScore: [this.grades?.highSchoolGrades?.type === 'Percentage' ? this.grades?.highSchoolGrades?.score : ''],
        classRank: [this.grades?.highSchoolGrades?.classRank ?? 0],
        classSize: [this.grades?.highSchoolGrades?.classSize ?? 0],
        UnderGraduateCGPACheck: [this.grades?.underGraduateCollegeGrade?.type === 'CGPA' ? true : false],
        UnderGraduateCGPAScore: [this.grades?.underGraduateCollegeGrade?.type === 'CGPA' ? this.grades?.underGraduateCollegeGrade?.score : 0],
        UnderGraduatePercentageCheck: [this.grades?.underGraduateCollegeGrade?.type === 'Percentage' ? true : false],
        UnderGraduatePercentageScore: [this.grades?.underGraduateCollegeGrade?.type === 'Percentage' ? this.grades?.underGraduateCollegeGrade?.score : 0],
        UnderGraduateClassRank: [this.grades?.underGraduateCollegeGrade?.classRank ?? 0],
        UnderGraduateClassSize: [this.grades?.underGraduateCollegeGrade?.classSize ?? 0],
        GraduateCGPACheck: [this.grades?.graduateCollegeGrade?.type === 'CGPA' ? true : false],
        GraduateCGPAScore: [this.grades?.graduateCollegeGrade?.type === 'CGPA' ? this.grades?.graduateCollegeGrade?.score : 0],
        GraduatePercentageCheck: [this.grades?.graduateCollegeGrade?.type === 'Percentage' ? true : false],
        GraduatePercentageScore: [this.grades?.graduateCollegeGrade?.type === 'Percentage' ? this.grades?.graduateCollegeGrade?.score : 0],
        GraduateClassRank: [this.grades?.graduateCollegeGrade?.classRank ?? 0],
        GraduateClassSize: [this.grades?.graduateCollegeGrade?.classSize ?? 0],
      },
        {
          validators: [classRankLessThanClassSizeValidator,undergraduateClassRankLessThanClassSizeValidator,graduateClassRankLessThanClassSizeValidator, atLeastOneCheckedValidator]
        }),
      courseWork: this.formBuilder.group({
        boardId: [this.courseWork?.boardId, Validators.required],
        otherBoardName: [this.courseWork?.otherBoardName],
        subjects: [this.courseWork?.subjects ?? [], Validators.required],
        otherSubjectName: [this.courseWork?.otherSubjectName],
        apTotal: [this.courseWork?.ap?.total ?? 0, Validators.required], // Fallback to 0 if total is undefined
        apSubjects: this.formBuilder.array([])
      }),
      extraCurricular: this.formBuilder.group({
        activityDetails: this.formBuilder.array([])
      }),
      technicalSkills: this.formBuilder.array([]),
      licensesAndCertifications: this.formBuilder.array([])
    });

    this.setAPExams();
    this.setAPSubjects();
    this.setEducationLevelValidation();
    this.setTechnicalSkills();
    this.setLicensesCertifications();
  }

  private setEducationLevelValidation(){
    const demographyGroup = this.completeProfileForm.get('demography') as FormGroup;
    const educationControl = demographyGroup.get('highestLevelEducation');

    const undergraduationFields = [
      'underGraduateCollageName',
      'underGraduateMajorOrDegree',
      'underGraduateFieldOfStudy',
      'underGraduateStartDate',
      'underGraduateEndDate'
    ]
    const graduationFields = [
      'graduateCollageName',
      'graduateMajorOrDegree',
      'graduateFieldOfStudy',
      'graduateStartDate',
      'graduateEndDate'
    ]

    educationControl?.valueChanges.subscribe((value: string) => {
      undergraduationFields.forEach(field => {
        const control = demographyGroup.get(field);
        if(!control) return;

        if(value === 'Undergraduate degree' || value === 'Post Graduate degree'){
          control.setValidators([Validators.required]);
        }else{
          control.clearValidators();
        }
        control.updateValueAndValidity({onlySelf: true});
      });
      graduationFields.forEach(field => {
        const control = demographyGroup.get(field);
        if(!control) return;

        if(value === 'Post Graduate degree'){
          control.setValidators([Validators.required]);
        }else{
          control.clearValidators();
        }
        control.updateValueAndValidity({onlySelf: true});
      });
    })
    educationControl?.updateValueAndValidity();
  }

  setTechnicalSkills() {
    if (this.technicalSkillsResponse && Array.isArray(this.technicalSkillsResponse.result)) {
      if (this.technicalSkillsResponse.result.length > 0) {
        this.technicalSkillsResponse.result.forEach((activity) => {
          const skillForm = this.createTechnicalSkill(activity);
          this.technicalSkills.push(skillForm);
          this.currentTechnicalSkillIndex++;
        });
      }
      else {
        const skillForm = this.createFreshTechnicalSkill();
        this.technicalSkills.push(skillForm);
        this.currentTechnicalSkillIndex++;
      }
    }
    this.technicalSkillsLoaded = true;
  }

  setLicensesCertifications() {
    if (this.licensesCertificationsResponse && Array.isArray(this.licensesCertificationsResponse.result)) {
      if (this.licensesCertificationsResponse.result.length > 0) {
        this.licensesCertificationsResponse.result.forEach((activity) => {
          const licCertForm = this.createLicenseCertification(activity);
          this.licensesAndCertifications.push(licCertForm);
          this.currentLicenseAndCertificationIndex++;
        });
      }
      else {
        const skillForm = this.createFreshLicenseCertification();
        this.licensesAndCertifications.push(skillForm);
        this.currentLicenseAndCertificationIndex++;
      }
    }
    this.licenseAndCertificationLoaded = true;
  }

  createFreshTechnicalSkill(): FormGroup {
    return this.formBuilder.group({
      skillName: ['', Validators.required],
      skillDescription: ['', Validators.required],
    });
  }

  createTechnicalSkill(activity?: TechnicalSkills): FormGroup {
    return this.formBuilder.group({
      skillName: [activity?.skillName ?? '', Validators.required],
      skillDescription: [activity?.skillDescription ?? '', Validators.required],
    });
  }

  createFreshLicenseCertification(): FormGroup {
    return this.formBuilder.group({
      licenseOrCertificationName: ['', Validators.required],
      issuingOrganisation: ['', Validators.required],
      issueDate: [null, Validators.required],
    });
  }

  createLicenseCertification(activity?: LicenseCertification): FormGroup {
    return this.formBuilder.group({
      licenseOrCertificationName: [activity?.licenseOrCertificationName ?? '', Validators.required],
      issuingOrganisation: [activity?.issuingOrganisation ?? '', Validators.required],
      issueDate: [activity?.issueDate ? new Date(activity.issueDate) : null, Validators.required],
    });
  }

  setExtraCurricularActvities() {
    if (this.extraCurricularActivityResponse && Array.isArray(this.extraCurricularActivityResponse.result)) {
      // Proceed only if ExtracurricularActivity is defined and is an array
      if (this.extraCurricularActivityResponse.result.length > 0) {
        // Create activity for each item
        this.extraCurricularActivityResponse.result.forEach((activity) => {
          const activityForm = this.createActivity(activity);
          this.activityDetails.push(activityForm);
          this.currentActivityIndex++;
        });
      }
      else {
        // Push an empty activity if no data is found
        const activityForm = this.createFreshActivity();
        this.activityDetails.push(activityForm);
        this.currentActivityIndex++;
      }
    }
    this.activitiesLoaded = true;
  }

  // toggleActivityTierValidator(activityControlName: string, activities: Activity[] | undefined | null){
  //   return (control: AbstractControl): ValidationErrors | null => {
  //     const parent = control.parent;
  //     if(!parent)return null;
  //     const activityId = parent.get(activityControlName)?.value;
  //     const selectedActivity = activities?.find(activity => activity.id === activityId);

  //     if(selectedActivity?.name !== 'Professional Job' && !control.value){
  //       return {required: true};
  //     }
  //     return null;
  //   };
  // }

  loadActivities() {
    this.completeProfileService.getActivities().subscribe({
      next: (response) => {
        this.activities = response.result;
      }
    });
  }

  // Create individual activity group
  createFreshActivity(activity?: ActivityDetails): FormGroup {
    return this.formBuilder.group({
      activityId: ['', Validators.required],
      otherActivityName: [''],
      [`tier${this.currentActivityIndex}`]: [null/*, this.toggleActivityTierValidator('activityId', this.activities)*/],  // Use the value of activityIndex, not the incremented one
      organisationName: [activity?.organisationName ?? '', Validators.required],
      startDate: [activity?.startDate ? new Date(activity.startDate) : null, Validators.required],
      endDate: [activity?.endDate ? new Date(activity.endDate) : null, Validators.required],
      location: [activity?.location ?? '', Validators.required],
      // [`participationGradeLevels${this.currentActivityIndex}`]: [activity?.participationGradeLevels ?? '', Validators.required],
      positionInActivity: [activity?.positionInActivity ?? '', Validators.required]
    });
  }

  // Create individual activity group
  createActivity(activity?: ActivityDetails): FormGroup {
    return this.formBuilder.group({
      activityId: [activity?.activityId ?? '', Validators.required],
      otherActivityName: [activity?.otherActivityName ?? ''],
      [`tier${this.currentActivityIndex}`]: [activity?.levelOfAchievement ?? null/*, this.toggleActivityTierValidator('activityId', this.activities)*/],  // Use the value of activityIndex, not the incremented one
      organisationName: [activity?.organisationName ?? '', Validators.required],
      startDate: [activity?.startDate ? new Date(activity.startDate) : null, Validators.required],
      endDate: [activity?.endDate ? new Date(activity.endDate) : null, Validators.required],
      location: [activity?.location ?? '', Validators.required],
      // [`participationGradeLevels${this.currentActivityIndex}`]: [activity?.participationGradeLevels ?? '', Validators.required],
      positionInActivity: [activity?.positionInActivity ?? '', Validators.required]
    });
  }

  // Get form array
  get activityDetails(): FormArray {
    return this.completeProfileForm.get('extraCurricular.activityDetails') as FormArray;
  }

  get technicalSkills(): FormArray {
    return this.completeProfileForm.get('technicalSkills') as FormArray;
  }
  get licensesAndCertifications(): FormArray {
    return this.completeProfileForm.get('licensesAndCertifications') as FormArray;
  }

  addSkill(): void {
    this.submitted = false;
    this.technicalSkills.push(this.createFreshTechnicalSkill());
    this.currentTechnicalSkillIndex++;
  }
  removeSkill(index: number): void {
    this.technicalSkills.removeAt(index);
    this.currentTechnicalSkillIndex--;
  }

  addLicense(): void {
    this.submitted = false;
    this.licensesAndCertifications.push(this.createFreshLicenseCertification());
    this.currentLicenseAndCertificationIndex++;
  }
  removeLicense(index: number): void {
    this.licensesAndCertifications.removeAt(index);
    this.currentLicenseAndCertificationIndex--;
  }

  // Add new activity form group to form array
  addActivity(): void {
    this.submitted = false;
    this.activityDetails.push(this.createFreshActivity());
    this.currentActivityIndex++;
  }

  // Remove activity form group from form array
  removeActivity(index: number): void {
    this.activityDetails.removeAt(index);
    this.currentActivityIndex--;
  }

  setAPSubjects() {
    if (this.courseWork && this.courseWork.ap && Array.isArray(this.courseWork.ap.apSubjects)) {
      // Proceed only if aPSubjects is defined and is an array
      if (this.courseWork.ap.apSubjects.length > 0) {
        this.courseWork.ap.apSubjects.forEach((subject) => this.addApSubjectCourseWork(subject));
      }
    }
  }



  get apSubjectsCourseWork() {
    return this.completeProfileForm.get('courseWork.apSubjects') as FormArray;
  }

  // Function to add a new subject (textbox)
  addApSubjectCourseWork(subject: string) {
    this.apSubjectsCourseWork.push(this.formBuilder.control(subject));
  }

  // Function to remove a subject (textbox)
  removeApSubjectCourseWork(index: number) {
    this.apSubjectsCourseWork.removeAt(index);
  }

  // Function to update subjects based on apTotal
  updateAPSubjectsCourseWork() {
    const total = this.completeProfileForm.get('courseWork.apTotal').value;
    const currentLength = this.apSubjectsCourseWork.length;

    if (total > currentLength) {
      // Add new subjects if apTotal increases
      for (let i = currentLength; i < total; i++) {
        this.addApSubjectCourseWork('');
      }
    } else if (total < currentLength) {
      // Remove extra subjects if apTotal decreases
      for (let i = currentLength - 1; i >= total; i--) {
        this.removeApSubjectCourseWork(i);
      }
    }
  }

 

  toggleGradeValidatorsGeneric(
    selectedType: 'CGPA' | 'Percentage',
    controlName: string,
    value: number,
    level: 'HighSchool' | 'UnderGraduate' | 'Graduate'
  ) {
    // Map level to actual control name prefixes
    const prefixMap = {
      HighSchool: '',
      UnderGraduate: 'UnderGraduate',
      Graduate: 'Graduate',
    };
  
    const prefix = prefixMap[level];
  
    // Resolve dynamic control names
    const cgpaCheckControl = this.completeProfileForm.get(`grades.${prefix}CGPACheck`);
    const percentageCheckControl = this.completeProfileForm.get(`grades.${prefix}PercentageCheck`);
    const scoreControl = this.completeProfileForm.get(`grades.${controlName}`);
  
    const cgpaScoreControl = this.completeProfileForm.get(`grades.${prefix}CGPAScore`);
    const percentageScoreControl = this.completeProfileForm.get(`grades.${prefix}PercentageScore`);
  
    if (selectedType === 'CGPA') {
      cgpaCheckControl?.setValue(true);
      percentageCheckControl?.setValue(false);
  
      scoreControl?.setValidators([Validators.required, CustomValidators.lte(value)]);
      percentageScoreControl?.clearValidators();
      percentageScoreControl?.updateValueAndValidity();
    }
  
    if (selectedType === 'Percentage') {
      cgpaCheckControl?.setValue(false);
      percentageCheckControl?.setValue(true);
  
      scoreControl?.setValidators([Validators.required, CustomValidators.lte(value)]);
      cgpaScoreControl?.clearValidators();
      cgpaScoreControl?.updateValueAndValidity();
    }
  
    scoreControl?.updateValueAndValidity();
  }

  setAPExams() {
    if (this.testScore) {
      if (this.testScore.apExams.length > 0) {
        this.testScore.apExams.forEach((exam) => this.addAPExam(exam.subjectName, exam.subjectScore.toString()));
      }
    }
  }


  // Getter for accessing the apExams FormArray
  get apExams(): FormArray {
    return this.completeProfileForm.get('testScoreForm.apExams') as FormArray;
  }

  // Method to add an AP Exam with both controls
  addAPExam(subjectName?: string, subjectScore?: string): void {
    const examGroup = this.formBuilder.group({
      subjectName: [subjectName, Validators.required],
      subjectScore: [subjectScore, Validators.required]
    });
    this.apExams.push(examGroup);
  }

  // Method to remove an AP Exam by index
  removeAPExam(index: number): void {
    this.apExams.removeAt(index);
  }

  onHighSchoolNameSelection() {
    const highSchoolNameControl = this.completeProfileForm.get('demography.highSchoolName');
    const isNotListedControl = this.completeProfileForm.get('demography.highSchoolNameisNotListed');
    if (highSchoolNameControl?.value && isNotListedControl) {
      isNotListedControl.clearValidators();
    } else {
      isNotListedControl?.setValidators(Validators.required);
    }
    isNotListedControl.updateValueAndValidity();
  }

  onhighSchoolNameisNotListedChange() {
    const highSchoolNameControl = this.completeProfileForm.get('demography.highSchoolName');
    const isNotListedControl = this.completeProfileForm.get('demography.highSchoolNameisNotListed');
    if (isNotListedControl?.value) {
      highSchoolNameControl?.clearValidators();
    } else {
      highSchoolNameControl?.setValidators(Validators.required);
    }
    highSchoolNameControl.updateValueAndValidity();
  }

  back() {
    if (this.currentStep > 0) this.currentStep -= 1;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  dateTimeToDateOnlyFormat(date: Date){
   const year = date.getFullYear();
   const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
   const day = date.getDate().toString().padStart(2, '0');
   return `${year}-${month}-${day}`;
  }

  continue() {
    this.submitted = true;
    this.loading = true;
    if (this.currentStep === steps.demography) {
      if (this.completeProfileForm.controls['demography'].invalid) {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const demographyForm: DemographyRequest = this.completeProfileForm.value.demography;
      const { householdIncome, familySpendingAbility } = this.completeProfileForm.value.demography;
      demographyForm.householdIncome = householdIncome.toString();
      demographyForm.familySpendingAbility = familySpendingAbility.toString();
      demographyForm.highSchoolStartDate = demographyForm.highSchoolStartDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.highSchoolStartDate)) : '';
      demographyForm.highSchoolEndDate = demographyForm.highSchoolEndDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.highSchoolEndDate)) : '';
      if(demographyForm.underGraduateStartDate){
        demographyForm.underGraduateStartDate = demographyForm.underGraduateStartDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.underGraduateStartDate)) : null;
        demographyForm.underGraduateEndDate = demographyForm.underGraduateEndDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.underGraduateEndDate)) : null;
      }
      if(demographyForm.graduateStartDate){
        demographyForm.graduateStartDate = demographyForm.graduateStartDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.graduateStartDate)) : null;
        demographyForm.graduateEndDate = demographyForm.graduateEndDate ? this.dateTimeToDateOnlyFormat(new Date(demographyForm.graduateEndDate)) : null;
      }
      this.updateDemography(demographyForm);
    }
    if (this.currentStep === steps.testscore) {
      if (this.completeProfileForm.controls['testScoreForm'].invalid || !this.checkStandarisedTestValid()
        || !this.checkEnglishTestValid()) {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const testScoreRequestForm = this.completeProfileForm.value.testScoreForm;
      var request: TestScoreRequest = {
        satScores: testScoreRequestForm.satScores,
        actScores: testScoreRequestForm.actScores,
        greScores: testScoreRequestForm.greScores,
        gmatScores: testScoreRequestForm.gmatScores,
        isStanardizedTestNotGiven: testScoreRequestForm.isStanardizedTestNotGiven,
        apExams: testScoreRequestForm.apExams,
        toeflScores: testScoreRequestForm.toeflScores,
        ieltsScores: testScoreRequestForm.ieltsScores,
        duolingoScores: testScoreRequestForm.duolingoScores,
        isEnglishProficiencyTestNotGiven: testScoreRequestForm.isEnglishProficiencyTestNotGiven,
      }
      this.updateTestScore(request);
    }
    if (this.currentStep == steps.grades) {
      if (this.completeProfileForm.controls['grades'].invalid) {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var gradeForm = this.completeProfileForm.value.grades;
      this.updateGrades({
        highSchoolGrades: {
          type: gradeForm.CGPACheck ? 'CGPA' : 'Percentage',
          score: gradeForm.CGPACheck ? gradeForm.CGPAScore : gradeForm.PercentageScore,
          classRank: gradeForm.classRank,
          classSize: gradeForm.classSize
        },
        underGraduateCollegeGrade: {
          type: gradeForm.UnderGraduateCGPACheck ? 'CGPA' : 'Percentage',
          score: gradeForm.UnderGraduateCGPACheck ? gradeForm.UnderGraduateCGPAScore : gradeForm.UnderGraduatePercentageScore,
          classRank: gradeForm.UnderGraduateClassRank ,
          classSize: gradeForm.UnderGraduateClassSize ,
        },
        graduateCollegeGrade: {
          type: gradeForm.GraduateCGPACheck ? 'CGPA' : 'Percentage',
          score: gradeForm.GraduateCGPACheck ? gradeForm.GraduateCGPAScore : gradeForm.GraduatePercentageScore,
          classRank: gradeForm.GraduateClassRank ,
          classSize: gradeForm.GraduateClassSize ,
        }
      });
    }
    if (this.currentStep == steps.coursework) {
      if (this.completeProfileForm.controls['courseWork'].invalid) {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      var courseworkForm = this.completeProfileForm.value.courseWork;
      this.updateCourseWork({
        boardId: courseworkForm.boardId,
        otherBoardName: courseworkForm.otherBoardName,
        subjects: courseworkForm.subjects,
        otherSubjectName: courseworkForm.otherSubjectName,
        aP: {
          total: courseworkForm.apTotal,
          aPSubjects: courseworkForm.apSubjects
        }
      });
    }
    if (this.currentStep == steps.extracurricular) {
      if (this.completeProfileForm.controls['extraCurricular'].invalid || 
        this.completeProfileForm.controls['technicalSkills'].invalid ||
        this.completeProfileForm.controls['licensesAndCertifications'].invalid) {
        this.loading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const formData = this.completeProfileForm.controls['extraCurricular'].value;
      const technicalSkillsFormData = this.completeProfileForm.controls['technicalSkills'].value;
      const licensesAndCertificationsFormData = this.completeProfileForm.controls['licensesAndCertifications'].value;
      this.updateExtraCurricular(formData);
      this.updateTechnicalSkills(technicalSkillsFormData);
      this.updateLicensesCertifications(licensesAndCertificationsFormData);
    }
  }

  private updateTechnicalSkills(formData: any){
    var request: TechnicalSkillsRequest = {
      technicalSkills: formData.map((item: TechnicalSkills) => {
        return {
          skillName: item.skillName,
          skillDescription: item.skillDescription
        };
      })
    }
    this.completeProfileService.addTechnicalSkills(request).subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.warn('Unable to update technical skills', error);
      },
      complete: () => {
      }
    })
  }

  private updateLicensesCertifications(formData: any){
    var request: LicensesCertificationsRequest = {
      licensesCertifications: formData.map((item: LicenseCertification) => {
        return {
          licenseOrCertificationName: item.licenseOrCertificationName,
          issuingOrganisation: item.issuingOrganisation,
          issueDate: item.issueDate
        };
      })
    }
    this.completeProfileService.addLicensesCertifications(request).subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.warn('Unable to update Licences/Certifications', error);
      },
      complete: () => {
      }
    })
  }

  private updateExtraCurricular(formData: any) {
    var request: ExtraCurricularActivityRequest = {
      activityDetails: formData.activityDetails.map((item: ActivityDetails, index: number) => {
        const tierKey = `tier${index}` as keyof ActivityDetails;
        const tierValue = parseInt(item[tierKey] as string, 10);
        const tier = isNaN(tierValue) || !(tierValue in LevelOfAchievement) ? null : tierValue as LevelOfAchievement;
        // const tierKey = `tier${index}` as keyof ActivityDetails;
        // const rawTier = item[tierKey];
        // const tier = rawTier === null || rawTier === undefined || rawTier === '' || rawTier === 0 
        //   ? null : Number(rawTier) as LevelOfAchievement;
        const participationGradeLevelsKey = `participationGradeLevels${index}` as keyof ActivityDetails;
        const participationGradeLevelsValue = item[participationGradeLevelsKey] as string;
        return {
          activityId: item.activityId,
          otherActivityName: item.otherActivityName, // Optional field
          levelOfAchievement: tier, // Set the correct tier based on the dynamic key
          organisationName: item.organisationName || null,
          participationGradeLevels:  null,
          startDate: item.startDate ? this.dateTimeToDateOnlyFormat(new Date(item.startDate)) : '',
          endDate: item.endDate ? this.dateTimeToDateOnlyFormat(new Date(item.endDate)) : '',
          location: item.location || null,
          positionInActivity: item.positionInActivity || null,
          //description: item.description || null
        };
      })
    }
    this.completeProfileService.addExtraCurricular(request).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile Details are updated!' });
        const storedData = JSON.parse(localStorage.getItem('account') ?? ''); // Retrieve and parse the stored JSON object
        const userId = storedData ? storedData.userId : null; // Access the userId property if it exists
        if (userId != null) {
          this.router.navigate(['portal', 'view-profile', userId])
        }
      },
      error: (error) => {
        console.warn('Unable to process the request', error);
      },
      complete: () => {
        this.loading = false;
        this.submitted = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }

  private updateCourseWork(courseWorkRequest: CourseWorkRequest) {
    this.completeProfileService.updateCourseWork(courseWorkRequest).subscribe({
      next: () => this.nextStep(),
      error: (error) => console.warn(error),
      complete: () => {
        this.loading = false;
        this.submitted = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    });
  }

  private updateGrades(gradeRequest: HighSchoolGradesRequest) {
    this.completeProfileService.updateGrades(gradeRequest).subscribe({
      next: () => this.nextStep(),
      error: (error) => console.warn(error),
      complete: () => {
        this.loading = false;
        this.submitted = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    });
  }

  private updateDemography(demographyForm: DemographyRequest) {
    this.completeProfileService.updateDemography(demographyForm).subscribe({
      next: () => this.nextStep(),
      error: (error) => console.warn(error),
      complete: () => {
        this.loading = false;
        this.submitted = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    });
  }

  private updateTestScore(testScoreRequest: TestScoreRequest) {
    this.completeProfileService.updateTestScore(testScoreRequest).subscribe({
      next: () => this.nextStep(),
      error: (error) => console.warn(error),
      complete: () => {
        this.loading = false;
        this.submitted = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    });
  }

  visible: boolean = false;

  showDialog() {
    this.visible = true;
  }

  nextStep() {
    if (this.currentStep < 4) this.currentStep += 1;
  }

  onTestCheckboxChange(): void {
    // Check if any of the test score checkboxes are selected
    const anyTestChecked = this.completeProfileForm.get('testScoreForm.satScoreCheck')?.value ||
      this.completeProfileForm.get('testScoreForm.actScoresCheck')?.value ||
      this.completeProfileForm.get('testScoreForm.greScoresCheck')?.value ||
      this.completeProfileForm.get('testScoreForm.gmatScoresCheck')?.value;

    if (anyTestChecked) {
      // Uncheck 'isStanardizedTestNotGiven' if any of the test checkboxes are selected
      this.completeProfileForm.get('testScoreForm.isStanardizedTestNotGiven')?.setValue(false);
    }


    this.toggleValidators('satScoreCheck', 'satScores');
    this.toggleValidators('actScoresCheck', 'actScores');
    this.toggleValidators('greScoresCheck', 'greScores');
    this.toggleValidators('gmatScoresCheck', 'gmatScores');
  }

  onEnglishTestCheckboxChange(): void {
    // Check if any of the test score checkboxes are selected
    const anyTestChecked = this.completeProfileForm.get('testScoreForm.toeflScoresCheck')?.value ||
      this.completeProfileForm.get('testScoreForm.ieltsScoresCheck')?.value ||
      this.completeProfileForm.get('testScoreForm.duolingoScoresCheck')?.value

    if (anyTestChecked) {
      // Uncheck 'isEnglishProficiencyTestNotGiven' if any of the test checkboxes are selected
      this.completeProfileForm.get('testScoreForm.isEnglishProficiencyTestNotGiven')?.setValue(false);
    }

    this.toggleValidators('toeflScoresCheck', 'toeflScores');
    this.toggleValidators('ieltsScoresCheck', 'ieltsScores');
    this.toggleValidators('duolingoScoresCheck', 'duolingoScores');
  }

  onNoStandardisedTestGivenChange(event: any) {
    // Check if the checkbox is unchecked
    const isChecked = event.checked;

    // If unchecked, set all other test score checkboxes to false
    if (isChecked) {
      this.completeProfileForm.get('testScoreForm.satScoreCheck').setValue(false);
      this.completeProfileForm.get('testScoreForm.actScoresCheck').setValue(false);
      this.completeProfileForm.get('testScoreForm.greScoresCheck').setValue(false);
      this.completeProfileForm.get('testScoreForm.gmatScoresCheck').setValue(false);

      // Optionally, reset the test score values as well
      this.completeProfileForm.get('testScoreForm.satScores').setValue(null);
      this.completeProfileForm.get('testScoreForm.actScores').setValue(null);
      this.completeProfileForm.get('testScoreForm.greScores').setValue(null);
      this.completeProfileForm.get('testScoreForm.gmatScores').setValue(null);
      // Call the onTestCheckboxChange to handle form updates
      this.onTestCheckboxChange();
    }
  }

  onNoEnglishTestGivenChange(event: any) {
    // Check if the checkbox is unchecked
    const isChecked = event.checked;

    // If unchecked, set all other test score checkboxes to false
    if (isChecked) {
      this.completeProfileForm.get('testScoreForm.toeflScoresCheck').setValue(false);
      this.completeProfileForm.get('testScoreForm.ieltsScoresCheck').setValue(false);
      this.completeProfileForm.get('testScoreForm.duolingoScoresCheck').setValue(false);

      // Optionally, reset the test score values as well
      this.completeProfileForm.get('testScoreForm.toeflScores').setValue(null);
      this.completeProfileForm.get('testScoreForm.ieltsScores').setValue(null);
      this.completeProfileForm.get('testScoreForm.duolingoScores').setValue(null);
      // Call the onTestCheckboxChange to handle form updates
      this.onTestCheckboxChange();
    }
  }

  toggleValidators(checkboxName: string, controlName: string) {
    const checkbox = this.completeProfileForm.get(`testScoreForm.${checkboxName}`)?.value;
    const control = this.completeProfileForm.get(`testScoreForm.${controlName}`);

    if (checkbox) {
      control?.setValidators([Validators.required]);
    } else {
      control?.clearValidators();
    }
    control?.updateValueAndValidity();
  }

  checkStandarisedTestValid() {
    return this.completeProfileForm.get('testScoreForm.satScoreCheck').value
      || this.completeProfileForm.get('testScoreForm.actScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.greScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.gmatScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.isStanardizedTestNotGiven').value
  }

  checkEnglishTestValid() {
    return this.completeProfileForm.get('testScoreForm.toeflScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.ieltsScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.duolingoScoresCheck').value
      || this.completeProfileForm.get('testScoreForm.isEnglishProficiencyTestNotGiven').value
  }

  getActivityGroup(index: number): FormGroup {
    return this.activityDetails.at(index) as FormGroup;
  }
  getTechnicalSkillGroup(index: number): FormGroup {
    return this.technicalSkills.at(index) as FormGroup;
  }
  getLicenseCertificationlGroup(index: number): FormGroup {
    return this.licensesAndCertifications.at(index) as FormGroup;
  }
}
